// extracted by mini-css-extract-plugin
export default {"pay_button_wrap":"calender_pay_button_wrap__gQE-E","btn_info":"calender_btn_info__a3umI","pay_btn":"calender_pay_btn__Q3+0R"};